var React = require('react');

function MicOff (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M13.9,7.6h-1.4c0,0.6-0.1,1.2-0.4,1.7l1,1C13.6,9.5,13.9,8.6,13.9,7.6z M10.5,7.7c0-0.1,0-0.1,0-0.1V2.5\n\t\tC10.5,1.1,9.4,0,8,0S5.5,1.1,5.5,2.5v0.2L10.5,7.7z M1.5,0.8L0.4,1.9L5.5,7v0.6c0,1.4,1.1,2.5,2.5,2.5c0.2,0,0.4,0,0.5-0.1l1.4,1.4\n\t\tc-0.6,0.3-1.3,0.4-1.9,0.4c-2.3,0-4.5-1.8-4.5-4.3H2.1c0,2.9,2.3,5.2,5.1,5.7V16h1.7v-2.8c0.8-0.1,1.5-0.4,2.1-0.8l3.5,3.5l1.1-1.1\n\t\tL1.5,0.8z"})));
}

MicOff.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = MicOff;

MicOff.default = MicOff;
